import React from "react";
import { ProductsTable } from "../../components/datatable/productsDatatable";

const Products = () => {
  return <ProductsTable />;
};

export default Products;
